export default {
    getBanner: (data) => window.axios.post('get_banner', data),
    getBannerCategory: (data) => window.axios.post('banner_with_category', data),
    getBannerDine: (data) => window.axios.post('get_all_banner', data),
    // getBannerDine: (data) => window.axios.post('get_banner/dine_in', data),
    getAdsBanner:(data)=> window.axios.post('get-ads-banner', data),
}